import { render, staticRenderFns } from "./LearningPageContent.vue?vue&type=template&id=446075e0"
import script from "./LearningPageContent.vue?vue&type=script&lang=js"
export * from "./LearningPageContent.vue?vue&type=script&lang=js"
import style0 from "./LearningPageContent.vue?vue&type=style&index=0&id=446075e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports